import axios from "axios";
import { Brand } from "models/BO/Brand";
import { makeRequest, networkGlobals } from "./networkUtils";
import { BrandContact } from "models/BO/BrandContact";

const getHost = () => {

    return  networkGlobals.serverHost;
};


const currentHost = getHost();

/** tost credentionals for auth */
export const getBrandsDO = async (): Promise<Brand[]> => {
    return makeRequest(`brands`);
}
export const getFullBrandsDO = async (): Promise<Brand[]> => {
    return makeRequest(`brands/full`);
}

export const getBrandsStatsDO = async (): Promise<any> => {
    return makeRequest(`brands/stats`);
}

export const brandLogo = (brand?: Brand): string => {
    return `https://alove-dev-assets.s3.amazonaws.com/public/uploaded/${brand?.folder}/png/app_logo.png`

}

/** get brands by name */
export const getBrandByNmeDO = async (name):Promise<Brand> => {
    return makeRequest(`brands/${name}`);
}

/** get contact by brand */
export const getContactByBrandDO = async (id):Promise<BrandContact[]> => {

    return makeRequest(`brands/${id}/contacts`);
}

/** get count open tickets */
export const getCountTickets = async ( where) => {
    return makeRequest(`brands/tickets?where=${where}`);
}

/** update contact */
export const updateContactDO = async (data) => {
     return makeRequest(`brands/contacts/${data.id}`, {method: 'PUT', body: data});
};

/** post contact */
export const postNewRoleDO = async (data) => {
    return makeRequest(`brands/${data.brand}/contacts`, {method: 'POST', body: data});

};

/** delete contact */
export const deleteRoleDO = async ( id) => {
    return makeRequest(`brands/contacts/${id}`, {method: 'DELETE'});
};

/** update brand status */
export const updateBrandStatusDO = async (status, id) => {
    return makeRequest(`brands/${id}/status`, {method: 'PUT', body: {status}});
};

/** get users per brand */
export const countUserForBrandDO = async () => {
    return makeRequest(`brands/users`);
}